export const removeDuplicates = (arr) => {
	return [...new Set(arr)];
};

export const flattenArray = (arr) => {
	return arr.reduce((acc, it) => [...acc, ...it]);
};

export const indexArray = (arr, key) => {
	return arr.reduce((acc, it) => (acc[it[key]] = it, acc), {}); // eslint-disable-line
};

export const filterUnique = (arr, key) => {
	return [...new Set(arr.map(it => it[key]))];
};

export const objToQueryString = (params) => {
	return Object.entries(params).map(p => encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1])).join('&');
};

export const arrToQueryString = (arr = [], key = '') => {
	return arr.map(p => encodeURIComponent(key) + '=' + encodeURIComponent(p)).join('&');
};
